import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BuyNowPromptComponent } from './buynow-prompt.component';
import { ValueConverter } from '@angular/compiler/src/render3/view/template';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
  selector: 'app-confirmation-prompt',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {

  title = 'Please Confirm';
  message: string[];
  htmlMessage: SafeHtml;
  buttons: {label:string, value:any, color:any}[] = [{label:'Ok', value:true, color:'primary'}];
  showClose;
  closeLabel;
  msgHeight;

  constructor(private _sanitizer: DomSanitizer, public dialogRef: MatDialogRef<ConfirmationComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    dialogRef._containerInstance._config.autoFocus = false;
    dialogRef._containerInstance._config.restoreFocus = false;
    this.message = data.promptMessage;
    if (data.htmlMessage) {
      this.htmlMessage = _sanitizer.bypassSecurityTrustHtml(data.htmlMessage);
    }

    if (data.promptTitle) {
      this.title = data.promptTitle;
    }

    if (data.buttons) {
      this.buttons = data.buttons;
    }

    this.msgHeight = data.height != undefined ? data.height : '400';
    this.showClose = data.showClose != undefined ? data.showClose : true;
    this.closeLabel = data.closeLabel != undefined ? data.closeLabel : 'Close';

    console.log('data', data, this.showClose, this.closeLabel);
  }

  ngOnInit() {
  }

  buttonAction(value?): void {
    this.dialogRef.close(value);
  }
}

